import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { NO_ERROR_TOKEN } from '../interceptors/error.interceptor';
import { RoleEnum } from '../enums/role.enum';

/**
 * Mag deze gebruiker de pagina Usage van de club zien (01-11-2026)? De
 * clubbeheerder altijd; anderen alleen met het vinkje "Can see usage" dat de
 * clubbeheerder bij Users zet. Arch beslist (GET /Monitoring/club/access);
 * hier alleen voor het menu en de route. Eén keer per sessie gevraagd.
 */
@Injectable({ providedIn: 'root' })
export class UsageToegangService {
  private http = inject(HttpClient);
  private auth = inject(AuthService);
  private gevraagd$: Observable<boolean> | null = null;
  private voorSid = '';

  public magZien(): Observable<boolean> {
    const user = this.auth.user;
    if (!user) {
      return of(false);
    }
    if (isClubAdmin(user.role)) {
      return of(true);
    }
    if (!this.gevraagd$ || this.voorSid !== user.sid) {
      this.voorSid = user.sid;
      this.gevraagd$ = this.http.get<{ allowed: boolean }>(`${environment.apiUrl}/Monitoring/club/access`, {
        context: new HttpContext().set(NO_ERROR_TOKEN, ['usage_not_allowed']),
      }).pipe(
        map(r => !!r?.allowed),
        catchError(() => of(false)),
        shareReplay(1),
      );
    }
    return this.gevraagd$;
  }
}

function isClubAdmin(role: unknown): boolean {
  const key = typeof role === 'string' ? role : (role as { key?: string })?.key;
  return key === RoleEnum.CLUB_ADMIN;
}
